<div class="step-1" *ngIf="step == 'step-1'">
  <div class="text-center mb-5">
    <h3>SELECT YOUR CRYPTO CURRENCY WITHDRAWAL METHOD</h3>
  </div>
  <div class="d-flex justify-content-center align-items-center">
    <div class="trc20 mr-4 crypto-box" (click)="selectCryptoType('trc20')">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width: 4rem">
      <img src="../../../../assets/crypto/trc20.png" alt="" style="width: 4rem">
    </div>
    <div class="erc20 mr-4 crypto-box" (click)="selectCryptoType('erc20')">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width:4rem">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
    <div class="btc mr-4 crypto-box" (click)="selectCryptoType('btc')">
      <img src="../../../../assets/crypto/btc.png" alt="" style="width: 4rem">
    </div>
    <div class="ether crypto-box" (click)="selectCryptoType('ether')">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
</div>

<div class="my-2" *ngIf="cryptoType">
  <div class="column-center" *ngIf="cryptoType=='trc20'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width: 4rem">
      <img src="../../../../assets/crypto/trc20.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='erc20'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width:4rem">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='btc'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/btc.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='ether'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
</div>

<div class="step-2 m-4" *ngIf="step == 'step-2'">
  <div class="my-2" style="font-size: 1.2rem;" *ngIf="cryptoType">

    <div *ngIf="cryptoType=='trc20'">
      <div>
        <li><span class="danger-clr">ONLY send Tether (USDT)</span> to this deposit address.</li>
        <li><span class="danger-clr">Do NOT use</span> ERC20, BEP2, BEP20, OMNI, SOL, or other network standards as you
          may lose your deposit.</li>
        <li><span class="danger-clr">ONLY make deposits through the Tron (TRC20) network.</span></li>
        <li><span class="danger-clr">The use of contract addresses is not allowed.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          By clicking the "Confirm" button, you indicate that you agree to the above-mentioned risks.
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='erc20'">
      <div>
        <li><span class="danger-clr">ONLY send Tether (USDT)</span> to this deposit address.</li>
        <li><span class="danger-clr">Do NOT use</span> BEP2, BEP20, OMNI, TRC20, SOL or other network
          standards as you may lose your funds.</li>
        <li><span class="danger-clr">ONLY make deposits through the Ethereum (ERC20) network.</span></li>
        <li><span class="danger-clr">The use of contract addresses is not allowed.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          By clicking the "Confirm" button, you indicate that you agree to the above-mentioned risks.
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='ether'">
      <div>
        <li><span class="danger-clr">ONLY send Ethereum (mETH)</span> to this deposit address.</li>
        <li><span class="danger-clr">Do NOT use</span> BEP2, BEP20, or other network standards as you
          may lose your deposit.</li>
        <li><span class="danger-clr">ONLY make deposits through the Ethereum network.</span></li>
        <li><span class="danger-clr">The use of contract addresses is not allowed.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          By clicking the "Confirm" button, you indicate that you agree to the above-mentioned risks.
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='btc'">
      <div>
        <li><span class="danger-clr">ONLY send Bitcoin (µBTC)</span> to this deposit address.</li>
        <li><span class="danger-clr">Do NOT use</span> Lightning Network, BEP20, BEP2, ERC20, Polygon or other network
          standards as you may lose your deposit.</li>
        <li><span class="danger-clr">ONLY make deposits through the BTC network.</span></li>
        <li><span class="danger-clr">The use of contract addresses is not allowed.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          By clicking the "Confirm" button, you indicate that you agree to the above-mentioned risks.
        </div>
      </div>
    </div>

  </div>

  <button class="w-100 btn btn-success" (click)="confirm()">
    Confirm
  </button>
</div>

<div class="step-3 m-4" *ngIf="step == 'step-3'">
  <div class="mb-5 " style="font-size: 1.2rem;">
    <form [formGroup]="withDrawForm">
      <div class="d-flex align-items-center justify-content-between">
        <div>Amount (Min 100 MAD / Max 100 0000 MAD):</div>
        <div>
          <input id="amount" class="form-control p-inputtext-md" type="text" formControlName="amount" pInputText />
          <!-- <small *ngIf="isControlHasError('amount', 'required')" class="text-danger">
          {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small> -->
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mt-3">
        <div>Your Crypto address: </div>
        <div>
          <input id="address" class="form-control p-inputtext-md" type="text" formControlName="address" pInputText />
          <!-- <small *ngIf="isControlHasError('address', 'required')" class="text-danger">
          {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small> -->
        </div>
      </div>
    </form>
  </div>
  <p class="rule-box">
    <li>Please note that the exchange rate at the completion of the transaction may differ slightly from the above.
    </li>
    <li>Please be advised that processing your withdrawal may take up to 30 minutes.</li>
  </p>

  <button class="w-100 btn btn-success" (click)="confirm()">
    Confirm Withdrawal
  </button>
</div>